import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Routes, Route, usePanelHistoryTop } from 'weblite-router'
import { SignIn } from '$comp/signin'
import { SignUp } from '$comp/signup'
import { Verification } from '$comp/verification'
import { AuthStartingPage } from '$comp/auth-starting-page'
import { VisibilityHandler } from '$scenes/components/visibility-handler'
import { AuthSlider } from '$comp/auth-slider'
import config from '$config/frontend'
import { t } from '$i18n'

const StyledVideo = styled('video')`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  background-color: ${({ theme }) => theme.palette.neutral1000};
`

const LogoAndTitleContainer = styled('div')`
  position: absolute;
  top: 150px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const PAGES = {
  signIn: SignIn,
  verify: Verification,
  signUp: SignUp,
  startingPage: AuthStartingPage,
  slider: AuthSlider,
}

export function Auth() {
  const { state } = usePanelHistoryTop('root') || {}

  return (
    <VisibilityHandler
      style={{
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center',
      }}
      zIndex={1}
    >
      <StyledVideo playsInline autoPlay loop muted poster="">
        <source
          src={`${config.S3_HOST}/6f/d1/6fd1808d-c825-483c-8fab-5b6e6a611790.mp4`}
          type="video/mp4"
        />
      </StyledVideo>

      <LogoAndTitleContainer>
        <img
          style={{
            width: '200px',
            height: '100px',
            objectFit: 'cover',
          }}
          src="/assets/icons/jaryan-auth-logo.png"
          alt="jaryan-auth-logo"
        />

        <Typography variant="h3" color="neutral000" textAlign="center">
          {t('auth.title')}
        </Typography>
      </LogoAndTitleContainer>

      <Routes>
        {Object.keys(PAGES).map(page => {
          const Component = PAGES[page as keyof typeof PAGES]
          return (
            <Route key={page} name={page} element={<Component {...state} />} />
          )
        })}
      </Routes>
    </VisibilityHandler>
  )
}

//  TODO: i18n
